import useSound from "use-sound";

export const usePlayAudio = (audioFile: string) => {
  const [playAudio] = useSound(audioFile);

  return {
    playAudio,
  };
};
